import Block from './Block'
import gsap from 'gsap'
import App from '../App'
import { throttle } from 'throttle-debounce'

export default class Events extends Block {

  getElems() {
    this.datesWrapper = this.el.querySelector('.events__date-wrapper')
    this.datesDrag = this.datesWrapper.querySelectorAll('.item__date')
    this.itemsWrapper = this.el.querySelector('.events__wrapper')
    this.itemsContainer = this.el.querySelector('.events__items-container')
    this.items = this.itemsWrapper.querySelectorAll('.events__item')
    this.dates = this.el.querySelectorAll('.item__date')
    this.images = this.el.querySelectorAll('.item__image')
    this.links = this.el.querySelectorAll('.item__link')
    this.pagerWrapper = this.el.querySelector('.events__pagers-wrapper')
    this.pagerPagination = this.el.querySelector('.events__pagination_current')
    this.pagerLeft = this.el.querySelector('.events__pager-left')
    this.pagerRight = this.el.querySelector('.events__pager-right')
  }

  onEnterCompleted() {
    this.pagerWrapper.style.left = String((window.innerWidth - this.itemsContainer.offsetWidth) / 4) + 'px'
    this.pagerWrapper.style.top = String((this.itemsWrapper.offsetHeight - this.datesWrapper.offsetHeight) / 2 + this.datesWrapper.offsetHeight) + 'px'
    if (window.innerWidth < 1200) return

    this.getItemsSize()
    this.setDates()
  }

  setDates() {
    this.currentDateIndexActive = 0
    this.offsetLeft = null

    for (let i = 0; i < this.dates.length; i++) {
      this.dates[i].style.transform = 'translateX(-' + this.dateReducer * i + '%)'
      const rect = this.dates[i].getBoundingClientRect()

      this.dates[i].style.transform = 'none'
      this.dates[i].dataset.xactive = Number(rect.x)

      const rect2 = this.dates[i].getBoundingClientRect()

      if (!this.offsetLeft) this.offsetLeft = rect2.x

      this.dates[i].dataset.transformactive = rect2.x - this.offsetLeft
    }
  }

  getItemsSize() {
    this.elWidth = 0

    for (let i = 0; i < this.items.length - 1; i++) {
      const style = this.items[i].currentStyle || window.getComputedStyle(this.items[i])

      this.elWidth += this.items[i].offsetWidth + parseInt(style.marginLeft)
    }
  }

  init() {
    if (window.innerWidth < 1200) return

    this.canDrag = false
    this.elTransform = 0
    this.dateReducer = 60
  }

  bindMethods() {
    this.onDragStart = this.onDragStart.bind(this)
    this.onDrag = this.onDrag.bind(this)
    this.onDragEnd = this.onDragEnd.bind(this)
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onPagerClick = this.onPagerClick.bind(this)

    this.throttleDrag = throttle(20, this.onDrag)
  }

  events() {
    if (window.innerWidth < 1200) return

    for (let i = 0; i < this.datesDrag.length; i++) {
      this.datesDrag[i].addEventListener('mouseenter', this.onMouseEnter.bind(this, i))
      this.datesDrag[i].addEventListener('mouseleave', this.onMouseLeave.bind(this, i))
      this.datesDrag[i].addEventListener('mousedown', this.onDragStart.bind(this, i))
      this.datesDrag[i].addEventListener('click', this.onClick.bind(this, i))
    }

    this.pagerLeft.addEventListener('click', () => {
      this.onPagerClick(-1)
    })
    this.pagerRight.addEventListener('click', () => {
      this.onPagerClick(1)
    })
    window.addEventListener('mousemove', this.throttleDrag)
    window.addEventListener('mouseup', this.onDragEnd)

    for (let i = 0; i < this.images.length; i++) {
      this.images[i].addEventListener('click', this.onClick.bind(this, i))
    }
  }

  onPagerClick(direction) {
    if (direction === -1) {
      if (this.currentDateIndexActive === 0) return
    } else if (direction === 1) {
      if (this.currentDateIndexActive === this.items.length - 1) return
    }

    this.setActive(this.currentDateIndexActive + direction)
    this.onDragEnd()
  }

  onClick(i) {
    if (this.currentDateIndexActive === i) {
      if (this.links[i].tagName === 'A') {
        const win = window.open(this.links[i], '_blank')

        win.focus()
      }
    } else {
      this.setActive(i)
      this.onDragEnd()
    }
  }

  onMouseEnter(index) {
    if (this.currentDateIndexActive !== index) return

    App.cursor.setDragMode()
  }

  onMouseLeave(index) {
    if (this.currentDateIndexActive !== index) return

    App.cursor.resetDragMode()
  }

  clamp(num, a, b) {
    return Math.max(Math.min(num, Math.max(a, b)), Math.min(a, b))
  }

  onDragStart(index, e) {
    if (window.innerWidth < 1200 || this.currentDateIndexActive !== index) return

    this.canDrag = true
    this.currentDragPosition = e.clientX
    this.el.classList.add('drag')

    for (let i = 0; i < this.dates.length; i++) {
      gsap.to(this.dates[i], {
        x: -this.dateReducer * i + '%',
        duration: 0.6,
        ease: 'power2.out'
      })
    }

    this.elTransform = -this.dates[this.currentDateIndexActive].dataset.xactive + this.offsetLeft

    gsap.to(this.datesWrapper, {
      x: this.elTransform,
      duration: 0.6,
      ease: 'power2.out'
    })
  }

  onDrag(e) {
    if (!this.canDrag || window.innerWidth < 1200) return

    this.pagerLeft.classList.remove('visible')
    this.oldDragPosition = this.currentDragPosition
    this.currentDragPosition = e.clientX

    this.elTransform += (this.currentDragPosition - this.oldDragPosition) * 3
    this.elTransform = this.clamp(this.elTransform, -this.elWidth, 0)

    const t = this.elTransform * 2.325

    for (let i = 0; i < this.dates.length; i++) {
      if (Math.abs(this.elTransform) < Number(this.dates[i].dataset.xactive) && Math.abs(this.elTransform) > Number(this.dates[i].dataset.xactive) - 200 && this.currentDateIndexActive !== i) {
        this.setActive(i)
      }
    }

    gsap.to(this.datesWrapper, {
      x: this.elTransform,
      duration: 0.6,
      ease: 'power2.out'
    })

    gsap.to(this.itemsWrapper, {
      x: t,
      duration: 0.6,
      ease: 'power2.out'
    })
  }

  setActive(index) {
    this.dates[this.currentDateIndexActive].classList.remove('active')
    this.items[this.currentDateIndexActive].classList.remove('active')
    this.currentDateIndexActive = index
    this.pagerPagination.innerText = index + 1
    this.dates[this.currentDateIndexActive].classList.add('active')

    if (index > 0) this.pagerLeft.classList.add('visible')
    else if (this.pagerLeft.classList.contains('visible')) this.pagerLeft.classList.remove('visible')

    if (index < this.items.length - 1) this.pagerRight.classList.add('visible')
    else if (this.pagerRight.classList.contains('visible')) this.pagerRight.classList.remove('visible')
  }

  resize() {
    this.pagerWrapper.style.left = String((window.innerWidth - this.itemsContainer.offsetWidth) / 4) + 'px'
    this.pagerWrapper.style.top = String((this.itemsWrapper.offsetHeight - this.datesWrapper.offsetHeight) / 2 + this.datesWrapper.offsetHeight) + 'px'
    if (window.innerWidth < 1200) return

    gsap.set([this.datesWrapper, this.itemsWrapper], { x: 0 })
    this.setActive(0)
    this.getItemsSize()
    this.setDates()
  }

  onDragEnd() {
    if (window.innerWidth < 1200) return

    this.canDrag = false
    this.el.classList.remove('drag')

    const tl = gsap.timeline({
      onComplete: () => {
        if (this.currentDateIndexActive > 0) this.pagerLeft.classList.add('visible')
        this.items[this.currentDateIndexActive].classList.add('active')
      }
    })

    tl.to(this.dates, {
      x: '0%',
      duration: 0.6,
      ease: 'power2.out'
    })

    this.elTransform = -this.dates[this.currentDateIndexActive].dataset.transformactive

    tl.to([this.datesWrapper, this.itemsWrapper], {
      x: this.elTransform,
      duration: 0.6,
      ease: 'power2.out'
    }, '-=0.6')


  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Events.js